<script setup>
// Som e aviso na tela para mensagens do Chat Interno, por usuário, no mesmo
// modelo dos alertas das conversas. Quem aplica é
// helper/AudioAlerts/alertasDoChatInterno.js.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import FormSelect from 'v3/components/Form/Select.vue';
import AudioAlertTone from './AudioAlertTone.vue';
import AudioAlertCondition from './AudioAlertCondition.vue';
import { configDoChatInterno } from 'dashboard/helper/AudioAlerts/alertasDoChatInterno';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const config = computed(() => configDoChatInterno(uiSettings.value));

const opcoes = computed(() => [
  {
    value: 'none',
    label: t(
      'PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.OPCOES.NENHUMA'
    ),
  },
  {
    value: 'mentions',
    label: t(
      'PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.OPCOES.MENCOES'
    ),
  },
  {
    value: 'all',
    label: t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.OPCOES.TODAS'),
  },
]);

const salvar = valor => {
  updateUISettings(valor);
  useAlert(t('PROFILE_SETTINGS.FORM.API.UPDATE_SUCCESS'));
};

const som = computed({
  get: () => config.value.som,
  set: valor => salvar({ internal_chat_audio_alert: valor }),
});

const aviso = computed({
  get: () => config.value.aviso,
  set: valor => salvar({ internal_chat_notice_alert: valor }),
});

const condicoes = computed(() => [
  {
    id: 'sempre',
    label: t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.SEMPRE'),
    model: config.value.sempre,
    value: 'internal_chat_always_alert',
  },
]);
</script>

<template>
  <div class="flex flex-col gap-6">
    <AudioAlertTone
      :value="config.tom"
      :label="t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.TOM')"
      @change="valor => salvar({ internal_chat_alert_tone: valor })"
    />
    <FormSelect
      v-model="som"
      name="internalChatAudio"
      spacing="compact"
      :value="som"
      :options="opcoes"
      :label="t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.SOM')"
    >
      <option
        v-for="opcao in opcoes"
        :key="opcao.value"
        :value="opcao.value"
        :selected="opcao.value === som"
      >
        {{ opcao.label }}
      </option>
    </FormSelect>
    <FormSelect
      v-model="aviso"
      name="internalChatNotice"
      spacing="compact"
      :value="aviso"
      :options="opcoes"
      :label="t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.AVISO')"
    >
      <option
        v-for="opcao in opcoes"
        :key="opcao.value"
        :value="opcao.value"
        :selected="opcao.value === aviso"
      >
        {{ opcao.label }}
      </option>
    </FormSelect>
    <AudioAlertCondition
      :items="condicoes"
      :label="t('PROFILE_SETTINGS.FORM.INTERNAL_CHAT_NOTIFICATIONS.QUANDO')"
      @change="(_id, valor) => salvar({ internal_chat_always_alert: valor })"
    />
  </div>
</template>
